module.exports = __webpack_public_path__ + "img/apoio-conicet.e7f92a26.png";